import * as React from "react";
import { IInputFieldProps, FieldSchema } from "@cak-legacy/generation-core";
import { getValueFromObject, useDataContext, useDependsOnHook } from "@cak-legacy/generation-overview-core";

export function withHideOnFieldHoc<T extends IInputFieldProps<FieldSchema>>(
  Component: React.ComponentType<T>
) {
  const component = (props: T) => {
    const data = useDataContext();

    if ((props.field.ui?.readOverview?.render ?? true) === false) {
      return <></>;
    }
    const value: string | null = getValueFromObject(data, props.name);

    if (props.field.ui?.readOverview?.hideWhenEmpty && !value) {
      return <></>;
    }

    const fieldName = props.name.substring(0, props.name.lastIndexOf(".")) ?? "";

    const result = useDependsOnHook(fieldName, props.field.dependsOn);
    if (result.hide) {
      return <></>;
    }

    return <Component {...props} />;
  };

  component.displayName = "WithHideOnFieldHoc";

  return component;
}
